export const handleSearch = (urlInput, id, navigate) => {
    const trimmedUrl = urlInput.trim();
    if (!trimmedUrl) return alert("URL을 입력해주세요!");
    const urlPattern = /^(https?:\/\/)?([\w.-]+\.[a-z]{2,})(\/\S*)?$/i;
    if (!urlPattern.test(trimmedUrl)) {
        alert("올바른 URL 형식이 아닙니다!");
        return;
    }
    if (!trimmedUrl.includes("naver.com") && !trimmedUrl.includes("daum.net")) {
        alert("현재는 네이버와 다음 뉴스만 지원합니다!");
        return;
    }
    navigate("/news", { state: { url: urlInput, id } });
};